import * as React from 'react';
import { NormalizedSearchResult, SearchOptions } from '../../common/d7/common';
import { getSearchResults } from '../../common/d7/search';
import { contentTypeToIcon } from '../../common/helpers/icons';
import { useInViewLoading } from '../../common/hooks/useInViewLoading';
import { useSearchResults } from '../../common/hooks/useSearchResults';
import { ImageRenditionPresets } from '../../common/image-rendition';
import { StyledHiddenTrigger, StyledLoader } from '../../common/loading';
import { useTranslations } from '../../common/translation';
import { ImageCards } from '../image-cards/ImageCards';
import { InstagramLoader } from '../instagram-loader/InstagramLoader';
import { BrandsCollectionsResultsProps } from './BrandsCollectionsResults.props';
import { StyledBrandsCollectionsNoResults, StyledBrandsCollectionsResults } from './BrandsCollectionsResults.styles';
import translations from './translations';

export const BrandsCollectionsResults = ({ contentType, query, skipItemPath }: BrandsCollectionsResultsProps) => {
  const { locale, t } = useTranslations(translations);

  const orderField = query.includes('collections') ? 'releaseDate' : 'title';
  const order = query.includes('collections') ? 'desc' : 'asc';
  const options: SearchOptions = {
    locale,
    orderField,
    order,
    irsPreset: ImageRenditionPresets.Promo,
  };
  if (skipItemPath) {
    Object.assign(options, { filterInfo: { field: 'url', value: skipItemPath, operation: 'not contains' } });
  }
  const { hasNextPage, isLoading, isQuerying, loadNextPage, searchResults } = useSearchResults(
    query,
    getSearchResults,
    options,
  );
  const inViewRef = useInViewLoading(loadNextPage, isQuerying);

  if (!isLoading && (searchResults || []).length === 0) {
    return <StyledBrandsCollectionsNoResults>{t('noResultsText', 'No results')}</StyledBrandsCollectionsNoResults>;
  }

  return (
    <StyledBrandsCollectionsResults>
      {isLoading && <InstagramLoader />}
      {!isLoading && (searchResults || []).length > 0 && (
        <>
          <ImageCards
            headingTag='h2'
            cards={(searchResults || []).map(({ image, title, url }: NormalizedSearchResult) => ({
              title,
              alt: image?.alt || title,
              src: image?.src || contentTypeToIcon[contentType],
              to: url,
            }))}
            ratio={0.8}
          />
          {hasNextPage() && (
            <>
              <StyledHiddenTrigger ref={inViewRef} />
              <StyledLoader isVisible={isQuerying} />
            </>
          )}
        </>
      )}
    </StyledBrandsCollectionsResults>
  );
};
